'use strict'

require('core-js/es6/array')
require('core-js/es6/object')
require('core-js/es6/function')
require('core-js/es6/string')


/*****************
 ** WEBPACK FOOTER
 ** ./polyfills.js
 ** module id = 1
 ** module chunks = 0
 **/